import { IVA_TYPE_10_PERCENT } from "./iva";

export interface ReceivedInvoiceItem {
  id?: number;
  receivedInvoiceId?: number;
  description?: string;
  obs?: string;
  measureUnit?: number;
  code?: string;
  unitAmount?: number;
  quantity?: number;
  totalAmount?: number;
  ivaType?: string;
  amount10Percent?: number;
  amount5Percent?: number;
  amountExempt?: number;
  taxed10Percent?: number;
  taxed5Percent?: number;
  ivaBase?: number;
  iva10Percent?: number;
  iva5Percent?: number;
}

export interface ReceivedInvoice {
  id?: number;
  taxPayerId?: number;
  establishmentCode?: string;
  dispatchPointIdentifier?: string;
  stampIdentifier?: string;
  stampBeginDate?: string;
  supplierId?: number;
  supplierRuc?: string;
  supplierSocialName?: string;
  supplierFantasyName?: string;
  clientRuc?: string;
  clientSocialName?: string;
  clientFantasyName?: string;
  invoiceDate?: string;
  saleType?: string;
  creationType?: string;
  currency?: string;
  pygExchangeRate?: number;
  description?: string;
  obs?: string;
  amount?: number;
  amount10Percent?: number;
  amount5Percent?: number;
  amountExempt?: number;
  taxed10Percent?: number;
  taxed5Percent?: number;
  iva10Percent?: number;
  iva5Percent?: number;
  invoiceNumber?: string;
  cdc?: string;
  xmlPath?: string;
  pdfPath?: string;
  items?: ReceivedInvoiceItem[];
  createdAt?: string;
  updatedAt?: string;
}

export const INVOICE_SALE_TYPE_CASH = "cash";
export const INVOICE_SALE_TYPE_CASH_LABEL = "Contado";
export const INVOICE_SALE_TYPE_CREDIT = "credit";
export const INVOICE_SALE_TYPE_CREDIT_LABEL = "Crédito";

export const newReceivedInvoice = (taxPayerId?: number): ReceivedInvoice => {
  return {
    taxPayerId: taxPayerId,
    items: [],
  };
};

export const newReceivedInvoiceItem = (): ReceivedInvoiceItem => {
  return {
    ivaType: IVA_TYPE_10_PERCENT,
    ivaBase: 100,
  };
};

export const formatReceivedInvoiceNumber = (
  invoice: ReceivedInvoice
): string => {
  return `${invoice.establishmentCode}-${invoice.dispatchPointIdentifier}-${invoice.invoiceNumber}`;
};
